import { Button, Text } from '@southfields-digital/mpxlive-components';
import { useDispatch } from 'react-redux';

import { REQUEST_HIDE_ALL_GRAPHICS } from 'src/redux/reducers/control';

export default function Header() {
  const dispatch = useDispatch();
  const hideAllActiveGraphics = () => {
    dispatch({ type: REQUEST_HIDE_ALL_GRAPHICS });
  };

  return (
    <div className="w-full flex items-center justify-between bg-elevated-1">
      <Text as="h4">On screen</Text>
      <Button buttonSize="small" variant="tertiary" onClick={hideAllActiveGraphics}>
        Hide all
      </Button>
    </div>
  );
}
